import { render } from "./Arhibash-main.vue?vue&type=template&id=7057a708&scoped=true&lang=pug"
import script from "./Arhibash-main.vue?vue&type=script&setup=true&lang=js"
export * from "./Arhibash-main.vue?vue&type=script&setup=true&lang=js"

import "./Arhibash-main.vue?vue&type=style&index=0&id=7057a708&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7057a708"]])

export default __exports__